import { useCopy } from "@/lib/copy";
import { ButtonLink } from "./Content";

export const JoinCta = () => {
  const t = useCopy();
  return (
    <section className="border-t border-line bg-mist" aria-labelledby="join-cta-heading" data-testid="join-cta">
      <div className="container-x flex flex-col gap-6 py-12 md:flex-row md:items-center md:justify-between md:py-16">
        <div>
          <h2 id="join-cta-heading" className="text-2xl font-extrabold tracking-tight text-brand sm:text-3xl" data-testid="join-cta-title">{t("footer.cta.title")}</h2>
          {t("footer.cta.text") && <p className="mt-2 text-ink-muted" data-testid="join-cta-text">{t("footer.cta.text")}</p>}
        </div>
        <div className="shrink-0"><ButtonLink to="/contact" testId="join-cta-button">{t("footer.cta.button")}</ButtonLink></div>
      </div>
    </section>
  );
};
